import { IDeleteMultipleBaseRequest } from '../../../models/request/base/deleteRequest';
import { IPLTuanSelectRequest } from '../../../models/request/danh-muc/IPLTuanSelectRequest';
import {
	eYCHTGroupActionTypeIds,
	IYCHTGroupChangeSelectedIds,
	IYCHTGroupCloseConfirm,
	IYCHTGroupCloseDetail,
	IYCHTGroupDeleteErr,
	IYCHTGroupDeleteStart,
	IYCHTGroupDeleteSuccess,
	IYCHTGroupLoadErr,
	IYCHTGroupLoadStart,
	IYCHTGroupLoadSuccess,
	IYCHTGroupSaveErr,
	IYCHTGroupSaveStart,
	IYCHTGroupSaveSuccess,
	IYCHTGroupSelectErr,
	IYCHTGroupSelectStart,
	IYCHTGroupSelectSuccess,
	IYCHTGroupShowConfirm,
	IYCHTGroupShowDetail,
} from '../../action-types/danh-muc/IYCHTGroupActionTypes';
import { BaseAction } from '../IBaseActionResult';
import { app_yeu_cau_ho_tro_group } from './../../../models/response/app-phuhuynh/app_yeu_cau_ho_tro_group';

export const ychtGroupActions = {
	loadStart: (): IYCHTGroupLoadStart => BaseAction(undefined, eYCHTGroupActionTypeIds.LOAD_START),
	loadSuccess: (respone: app_yeu_cau_ho_tro_group[]): IYCHTGroupLoadSuccess => BaseAction(respone, eYCHTGroupActionTypeIds.LOAD_SUCCESS),
	loadError: (messege: string): IYCHTGroupLoadErr => BaseAction(messege, eYCHTGroupActionTypeIds.LOAD_ERROR),

	selectStart: (request: IPLTuanSelectRequest): IYCHTGroupSelectStart =>
		BaseAction(request, eYCHTGroupActionTypeIds.SELECT_START),
	selectSuccess: (respone: app_yeu_cau_ho_tro_group[]): IYCHTGroupSelectSuccess => BaseAction(respone, eYCHTGroupActionTypeIds.SELECT_SUCCESS),
	selectError: (messege: string): IYCHTGroupSelectErr => BaseAction(messege, eYCHTGroupActionTypeIds.SELECT_ERROR),

	showDetail: (data?: app_yeu_cau_ho_tro_group): IYCHTGroupShowDetail => BaseAction(data, eYCHTGroupActionTypeIds.SHOW_DETAIL),
	closeDetail: (): IYCHTGroupCloseDetail => BaseAction(undefined, eYCHTGroupActionTypeIds.CLOSE_DETAIL),
	showConfirm: (): IYCHTGroupShowConfirm => BaseAction(undefined, eYCHTGroupActionTypeIds.SHOW_CONFIRM),
	closeConfirm: (): IYCHTGroupCloseConfirm => BaseAction(undefined, eYCHTGroupActionTypeIds.CLOSE_CONFIRM),
	changeSelectedIds: (ids: number[]): IYCHTGroupChangeSelectedIds => BaseAction(ids, eYCHTGroupActionTypeIds.CHANGE_SELECTED_IDS),
	deleteStart: (ids: IDeleteMultipleBaseRequest): IYCHTGroupDeleteStart => BaseAction(ids, eYCHTGroupActionTypeIds.DELETE_START),
	deleteSuccess: (): IYCHTGroupDeleteSuccess => BaseAction(undefined, eYCHTGroupActionTypeIds.DELETE_SUCCESS),
	deleteError: (message: string): IYCHTGroupDeleteErr => BaseAction(message, eYCHTGroupActionTypeIds.DELETE_ERROR),
	//SAVE
	saveStart: (data: app_yeu_cau_ho_tro_group): IYCHTGroupSaveStart => BaseAction(data, eYCHTGroupActionTypeIds.SAVE_START),
	saveSuccess: (): IYCHTGroupSaveSuccess => BaseAction(undefined, eYCHTGroupActionTypeIds.SAVE_SUCCESS),
	saveError: (message: string): IYCHTGroupSaveErr => BaseAction(message, eYCHTGroupActionTypeIds.SAVE_ERR),

};
